var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Descargar","placement":"top-start"}},[_c('el-button',{attrs:{"disabled":_vm.downloading,"circle":"","size":"small"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"fas fa-arrow-circle-down"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }